module.exports = __webpack_public_path__ + "static/media/bathroom_brown.161a115f.jpg";